import { useContext } from "react";
import { useStore } from "zustand";
import { ProjectStoreFormStore } from "../stores/projectStoreFormStore";
import { ProjectStoreFormStoreContext } from "../stores/ProjectStoreFormContext";

export function useProjectStoreFormStore<T>(
  selector: (state: ProjectStoreFormStore) => T,
): T {
  const store = useContext(ProjectStoreFormStoreContext);
  if (!store) {
    throw new Error(
      "useProjectStoreFormStore must be used within a ProjectStoreProvider",
    );
  }
  return useStore(store, selector);
}
